/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ReferencedEntityGuidDto } from './ReferencedEntityGuidDto';
import {
    instanceOfReferencedEntityGuidDto,
    ReferencedEntityGuidDtoFromJSON,
    ReferencedEntityGuidDtoFromJSONTyped,
    ReferencedEntityGuidDtoToJSON,
} from './ReferencedEntityGuidDto';

/**
 * @type CreateNumericEvaluationParameterDtoDefinition
 * 
 * @export
 */
export type CreateNumericEvaluationParameterDtoDefinition = ReferencedEntityGuidDto;


export function CreateNumericEvaluationParameterDtoDefinitionFromJSON(json: any): CreateNumericEvaluationParameterDtoDefinition {
    return CreateNumericEvaluationParameterDtoDefinitionFromJSONTyped(json, false);
}

export function CreateNumericEvaluationParameterDtoDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericEvaluationParameterDtoDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ReferencedEntityGuidDtoFromJSONTyped(json, true) };
    return  ReferencedEntityGuidDtoFromJSONTyped(json, true);
}

export function CreateNumericEvaluationParameterDtoDefinitionToJSON(value?: CreateNumericEvaluationParameterDtoDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfReferencedEntityGuidDto(value)) {
        return ReferencedEntityGuidDtoToJSON(value as ReferencedEntityGuidDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateNumericEvaluationParameterDtoDefinition interface.
 */
export function instanceOfCreateNumericEvaluationParameterDtoDefinition(value: any): value is CreateNumericEvaluationParameterDtoDefinition {
    if (instanceOfReferencedEntityGuidDto(value)) return true;
    return false;
}

